export default function Task({
  task,
  onTaskDoneToggle,
  onSelectTask,
  selectedForDelete,
  onSelectForDelete,
  deleteMode,
}) {
  return (
    <div className="flex shadow-sm bg-secondary rounded-md ">
      {deleteMode && (
        <div
          className={`flex items-center bg-gradient-to-l  rounded-sm min-h-16 px-3 py-3  ${
            selectedForDelete ? 'from-red-200' : 'from-secondary'
          }`}
          onClick={() => onSelectForDelete(task.id)}
        >
          <div
            className={`w-5 h-5  appearance-none  border-1 border-black rounded-full ${
              selectedForDelete ? 'bg-red-600/50' : ''
            }`}
          ></div>
        </div>
      )}

      <div
        className={`flex items-center  rounded-lg   min-h-14 pr-6 pl-3 py-2 space-x-4 w-full`}
      >
        <div
          className="flex flex-col flex-grow"
          onClick={() => onSelectTask(task.id)}
        >
          <div className="text-md">{task.name}</div>
          <p className="text-xs font-light opacity-70">{task.description}</p>
        </div>

        <input
          checked={task.done}
          onChange={() => onTaskDoneToggle(task.id)}
          type="checkbox"
          className="shrink-0 w-5 h-5  appearance-none  border-2 border-primary rounded-sm checked:accent-primary checked:appearance-auto"
        />
      </div>
    </div>
  );
}
